import { gql } from '@apollo/client';

export const isLastLessonInModuleQuery = gql`
  query IsLastLessonInModule($lessonId: MongoID!) {
    isLastLessonInModule(lessonId: $lessonId)
  }
`;

export default isLastLessonInModuleQuery;
